module.exports = __webpack_public_path__ + "img/waiting_for_activation.7346c42.jpg";